import React from "react";

import { Card, theme, Typography } from "antd";
const { Text } = Typography;


import styled from "styled-components";

import PropTypes from "prop-types";

export const CardSelectable = ({ title, description, onClick }) => {
	const { token : antToken } = theme.useToken();
        
	const StyledCard = styled(Card)`
		cursor: pointer;
		transition: background 0.2s ease-in-out, box-shadow 0.3s ease-in-out;
		border-width: 2px;
		border-style: solid;
		border-color: ${antToken.colorBorder};

		&:hover {
			background-color: ${antToken.controlItemBgHover};
			border-width: 3px;
		}

		&.selected {
			background-color: ${antToken.colorSelectedRowTable} !important;
			box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.3);
			border-width: 3px;
			border-color: ${antToken.colorPrimary};
		}
	`;
    
	return (
		<StyledCard
			title={<Text style={{ fontSize: "20px", fontWeight: "bold" }}>{title}</Text>}
			onClick={onClick}
			variant="borderless"
		>
			<Text style={{ fontSize: "18px" }}>{description}</Text>
		</StyledCard>
	);
};

CardSelectable.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	onClick: PropTypes.func,
};